var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgManagementGrundlagen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "model1-icon",
    viewBox: "0 0 198.25 198.25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".model1-icon .cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.23,198.25A66.07,66.07,0,0,1,71.85,159,64.58,64.58,0,0,1,68.37,149a66.48,66.48,0,0,1-1.26-27.71c.08-.47.16-.95.26-1.44a65.19,65.19,0,0,1,4.48-14.38l.26-.59a66,66,0,0,1,60.11-38.7c1.07,0,2.05,0,3,.07a65,65,0,0,1,11.6,1.56c1.32.29,2.65.63,4,1a66.38,66.38,0,0,1,34.48,24,66,66,0,0,1-53,105.34Zm0-129.86A64,64,0,0,0,74.1,105.8l-.26.58a63.31,63.31,0,0,0-4.33,13.92c-.1.47-.17.91-.24,1.37a63.83,63.83,0,0,0,4.57,36.41A63.85,63.85,0,1,0,183.51,94.21h0A64.22,64.22,0,0,0,150.17,71c-1.26-.37-2.54-.7-3.82-1a62.59,62.59,0,0,0-11.22-1.51C134.2,68.42,133.25,68.39,132.23,68.39ZM94.1,158.21H90.68l-.33-.44a1.77,1.77,0,0,1-.17-.24,12.24,12.24,0,0,1-1.82-6.62,16.72,16.72,0,0,1,.16-2.31l.14-.94H91l-.13,1.21c0,.37,0,.75,0,1.14s0,.48,0,.72,0,.38.05.54v.09l0,.25c0,.21,0,.38.09.55s.11.51.17.74a1.62,1.62,0,0,0,.06.22c0,.15.07.24.1.33.09.29.19.56.3.82s.1.26.16.39a.93.93,0,0,0,.08.17l.12.25a2.91,2.91,0,0,0,.18.35c.13.23.27.47.42.71l.23.35Zm-11.73-.6a55.58,55.58,0,0,1-3.5-8.53l1-.32-1,.32a56.08,56.08,0,0,1-2.58-16.85c0-.3,0-.61,0-.91l2.18.06c0,.28,0,.57,0,.85A54.08,54.08,0,0,0,81,148.43h0a53.57,53.57,0,0,0,3.36,8.19Zm-2.6-37.18L77.64,120a50.91,50.91,0,0,1,1.44-5.22,55.3,55.3,0,0,1,4.38-9.93l1.9,1.08a54,54,0,0,0-4.21,9.53A50.09,50.09,0,0,0,79.77,120.43Zm41-26.32L118.87,93q.48-.83,1-1.62a13.57,13.57,0,0,1,9.59-7.7l.44,2.14a11.38,11.38,0,0,0-8.08,6.54l-.1.18C121.39,93.07,121.07,93.58,120.76,94.11Zm-18.65-6.43-1.22-1.8a55.3,55.3,0,0,1,10.63-5.64l.21-.08a55.2,55.2,0,0,1,13.78-3.48l.41-.05c1.8-.2,3.62-.32,5.42-.35l0,2.18c-1.6,0-3.21.13-4.81.29l0,.06h-.43a53.32,53.32,0,0,0-13.76,3.45l-.21.08A53.9,53.9,0,0,0,102.11,87.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.72,97A12.48,12.48,0,0,1,123,105.35a12.7,12.7,0,0,1-1.7-2.4,12.47,12.47,0,0,1-1.51-5.61c0-.12,0-.24,0-.36a12.5,12.5,0,0,1,.48-3.42,11.17,11.17,0,0,1,.59-1.62,12.47,12.47,0,0,1,23.88,5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 162.25,
    cy: 150.01,
    r: 12.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.24,
    cy: 150.01,
    r: 12.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 132.24,
    cy: 132.23,
    r: 12.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.24,188.19a55.62,55.62,0,0,1-23.11-5c-.49-.23-1-.46-1.47-.71a55.25,55.25,0,0,1-7.78-4.61,56.16,56.16,0,0,1-10.79-10,56.18,56.18,0,0,1-10.22-18.77,56.08,56.08,0,0,1-2.58-16.85c0-.3,0-.61,0-.91a55.85,55.85,0,0,1,1-9.93c.08-.45.18-.9.28-1.36l0-.07a50.91,50.91,0,0,1,1.44-5.22,55.3,55.3,0,0,1,4.38-9.93c.74-1.32,1.55-2.64,2.42-3.91a55.86,55.86,0,0,1,15-15l1.22,1.8a53.91,53.91,0,0,0-14.43,14.45c-.83,1.22-1.61,2.48-2.32,3.75a54.46,54.46,0,0,0-4.21,9.54,50.09,50.09,0,0,0-1.38,5c-.11.5-.2.93-.28,1.37a52.76,52.76,0,0,0-1,9.57c0,.29,0,.58,0,.86a53.72,53.72,0,0,0,30.16,48.32c.47.24.94.46,1.41.67a53.78,53.78,0,1,0,22.2-102.76h-.86l0-2.18h.91a56,56,0,0,1,0,111.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160,163.92a43.91,43.91,0,0,1-18.15-4.51,59.13,59.13,0,0,1-6.42-3.5l-.16-.1c-.16-.11-.33-.21-.49-.33-.84-.54-1.69-1.12-2.52-1.71-1,.75-2.09,1.46-3.16,2.14-1.27.79-2.53,1.52-3.76,2.17a48.87,48.87,0,0,1-17,5.59,26.06,26.06,0,0,1-10.09-.57,13.28,13.28,0,0,1-7.86-5.36,1.37,1.37,0,0,1-.15-.21,13,13,0,0,1-1.66-8.93c1.18-8.37,8.47-17.86,19-24.77l1-.63c1.48-.94,3-1.82,4.63-2.64-.06-1.09-.09-2.2-.09-3.32,0-.74,0-1.48,0-2.21,0-1.16.12-2.37.24-3.58l0-.39a51.63,51.63,0,0,1,1-6,43.72,43.72,0,0,1,3-9.08c.47-1,1-2,1.56-3,.33-.58.69-1.15,1.07-1.7,2.67-3.95,5.94-6.54,9.44-7.49a11.85,11.85,0,0,1,3-.4c4.15,0,8.08,2.22,11.38,6.42A28.07,28.07,0,0,1,145.91,93c3.73,6.4,5.79,15,5.79,24.23,0,1.16,0,2.3-.1,3.47,1.51.78,3,1.62,4.36,2.49,7.55,4.74,13.64,10.86,17.13,17.22,3.6,6.56,4,12.64,1.22,17.11C171.65,161.77,166.46,163.92,160,163.92ZM113.24,123c-1.21.65-2.4,1.33-3.54,2.06-.33.2-.64.39-.94.6-9.91,6.48-17,15.61-18.07,23.26A10.8,10.8,0,0,0,92,156.37l.06.09,0,.06A11.09,11.09,0,0,0,98.77,161a24.13,24.13,0,0,0,9.25.5,46.43,46.43,0,0,0,16.28-5.35c1.18-.62,2.4-1.33,3.62-2.09.76-.48,1.52-1,2.27-1.51a33.7,33.7,0,0,1-4.57-2.93c-7.2-5.5-11.44-14-12.26-24.42C113.3,124.47,113.26,123.73,113.24,123Zm21.07,29.57c.54.37,1.1.75,1.67,1.11.17.12.3.21.44.29l.16.11a57.15,57.15,0,0,0,6.17,3.36c13,6.08,25.5,5.63,29.71-1.06,2.37-3.77,1.91-9.06-1.29-14.9-3.31-6-9.13-11.87-16.37-16.42-1.05-.66-2.15-1.3-3.27-1.91-.32,9.27-3.15,16.9-8.43,22.7a30.54,30.54,0,0,1-4.14,3.79,33.07,33.07,0,0,1-3,2C135.33,152,134.77,152.31,134.31,152.56Zm-2.06-1.49.07.05.32-.16c.55-.28,1.31-.67,2.19-1.2a29.79,29.79,0,0,0,2.81-1.87,28.05,28.05,0,0,0,3.84-3.52c5.12-5.61,7.77-13.12,7.89-22.34a50.59,50.59,0,0,0-7.39-2.92l-1.12-.33h0l-.15,0a37.27,37.27,0,0,0-8.49-1.34,31.78,31.78,0,0,0-3.83.36,41.42,41.42,0,0,0-4.62,1,50.84,50.84,0,0,0-8.37,3.15c0,1.06.06,2.12.13,3.14.79,10,4.63,17.67,11.42,22.86a32.75,32.75,0,0,0,4.93,3.08l.29.15Zm8.9-34.47.14,0c.44.12.88.24,1.32.38a52.54,52.54,0,0,1,6.86,2.64c0-.81.05-1.61.05-2.42,0-8.72-2-17.15-5.5-23.13a23.44,23.44,0,0,0-2-2.91c-2.86-3.65-6.21-5.58-9.66-5.58a9.75,9.75,0,0,0-2.45.32c-3,.81-5.82,3.09-8.19,6.61-.36.52-.68,1-1,1.56-.53.92-1,1.87-1.47,2.83a42.27,42.27,0,0,0-2.8,8.64,47.58,47.58,0,0,0-.95,6.08l-.05.4c-.09,1-.16,2-.19,3,0,.71,0,1.42,0,2.13s0,1.53,0,2.29a51.51,51.51,0,0,1,7.89-2.89,41.28,41.28,0,0,1,4.88-1,31.86,31.86,0,0,1,4.14-.38h.08A38.7,38.7,0,0,1,141.15,116.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.66,80.23a13.53,13.53,0,0,1-6.78-1.82,13.58,13.58,0,0,1-6.79-11.75A13.56,13.56,0,0,1,78.4,59.88h0A13.57,13.57,0,0,1,66.66,80.23Zm0-25A11.38,11.38,0,0,0,61,76.52a11.54,11.54,0,0,0,11.38,0A11.37,11.37,0,0,0,76.51,61h0a11.39,11.39,0,0,0-9.85-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.66,133.32A66.64,66.64,0,0,1,0,66.66,66.73,66.73,0,0,1,66.66,0,66,66,0,0,1,108,14.34l-1.35,1.72a63.82,63.82,0,0,0-40-13.88A64.56,64.56,0,0,0,2.18,66.66a64.45,64.45,0,0,0,28.65,53.62,60.32,60.32,0,0,0,6.56,3.86,63.87,63.87,0,0,0,29.27,7h.6l.08,2.18Zm48.56-21-1.55-1.55,1.56,1.54Zm15.46-27.06-1.54-.6,1.64.27A2.31,2.31,0,0,1,130.68,85.28Zm-2-.79Zm4.66-17.15-2.18-.08c0-.19,0-.4,0-.6h2.18C133.32,66.88,133.32,67.12,133.31,67.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.57,
    y: 90.17,
    width: 2.18,
    height: 42.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.75,
    y: 86.64,
    width: 2.18,
    height: 5.73,
    transform: "translate(-34.06 51.95) rotate(-30.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.41,
    y: 76.99,
    width: 2.18,
    height: 5.73,
    transform: "translate(-24.41 117.42) rotate(-59.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.16,
    y: 65.57,
    width: 17.15,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.45,
    y: 47.96,
    width: 23.43,
    height: 2.18,
    transform: "translate(-11.51 55.16) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.9,
    y: 27,
    width: 42.06,
    height: 2.18,
    transform: "translate(20.13 91.05) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.57,
    y: 1.09,
    width: 2.18,
    height: 42.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.3,
    y: 7.06,
    width: 2.18,
    height: 42.07,
    transform: "translate(-8.1 25.96) rotate(-30.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27,
    y: 23.37,
    width: 2.18,
    height: 42.06,
    transform: "translate(-24.4 46.52) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.09,
    y: 65.57,
    width: 42.07,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.05,
    y: 87.84,
    width: 42.06,
    height: 2.18,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -40.71, 25.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.38,
    y: 99.51,
    width: 31.37,
    height: 2.18,
    transform: "translate(-63.59 91.05) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.66,80.23a13.53,13.53,0,0,1-6.78-1.82,13.58,13.58,0,0,1-6.79-11.75A13.56,13.56,0,1,1,66.66,80.23Zm0-25A11.38,11.38,0,0,0,61,76.52a11.54,11.54,0,0,0,11.38,0,11.39,11.39,0,0,0-5.69-21.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.13,66.66a12.49,12.49,0,1,1-1.67-6.23A12.43,12.43,0,0,1,79.13,66.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.66,122.62A56.07,56.07,0,0,1,50,120.08a54.83,54.83,0,0,1-9.63-4c-.54-.28-1.08-.59-1.62-.89a55.91,55.91,0,0,1-11.72-9,56.52,56.52,0,0,1-8.8-11.47,56,56,0,0,1,89.93-65.56l-1.61,1.46a54.23,54.23,0,0,0-13-10.47,53.78,53.78,0,0,0-53.78,93.16c.53.3,1,.6,1.58.87a53.32,53.32,0,0,0,26.81,6.3l.06,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.57,121.34l-.32-2.16.13,0,.64,2.09A3,3,0,0,1,78.57,121.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "107.21 193.25 13.43 193.25 13.43 106.44 15.62 106.44 15.62 191.07 107.21 191.07 107.21 193.25"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.85,
    y: 104.26,
    width: 0.26,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.75,
    y: 158.52,
    width: 2.18,
    height: 33.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.6,
    y: 147.66,
    width: 0.23,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.52,
    y: 147.66,
    width: 54.9,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.22,
    y: 162.14,
    width: 20.07,
    height: 20.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "30.22 121.19 30.22 125.11 36.9 125.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.22,
    y: 130.4,
    width: 20.07,
    height: 10.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.22,
    y: 156.02,
    width: 0.77,
    height: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.39,
    y: 161.91,
    width: 2.18,
    height: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.6,
    y: 175.9,
    width: 30.6,
    height: 2.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.14 178.09 21.14 178.09 21.14 119 26.14 119 26.14 121.19 23.32 121.19 23.32 175.91 26.14 175.91 26.14 178.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.64 173.26 54.6 173.26 54.6 171.08 57.46 171.08 57.46 136.51 53.64 136.51 53.64 134.33 59.64 134.33 59.64 173.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.82,
    y: 92.47,
    width: 0.44,
    height: 2.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "193.27 94.65 184.39 94.65 184.39 92.47 191.09 92.47 191.09 9.79 108.41 9.79 108.41 72.26 106.22 72.26 106.22 7.6 193.27 7.6 193.27 94.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.24,
    y: 92.47,
    width: 0.73,
    height: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.13,67.91l-1.91-1.07c4.8-8.59,9.92-14.59,15.66-18.34a33.65,33.65,0,0,1,15.74-5.26c6.17-.62,13,0,18.88.62L184.26,46c-5.76-.64-12.46-1.21-18.43-.62a31.52,31.52,0,0,0-14.75,4.92C145.63,53.88,140.75,59.63,136.13,67.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "126.04 78.81 126.03 77.72 125.23 76.99 126.03 77.71 126.03 76.63 126.04 76.63 126.04 77.71 126.85 78.45 126.53 78.81 126.04 78.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.94 82.34 111.92 80.16 111.94 80.16 111.94 82.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.13,69.85,146,68a39,39,0,0,0,3.79-2.46A35.57,35.57,0,0,0,161.42,51c1.18-2.65,2.27-5,3.32-7.18,7.11-14.66,13.1-21.65,20.67-24.13l.68,2.07c-6.94,2.28-12.56,9-19.38,23-1.05,2.15-2.13,4.48-3.3,7.11a37.71,37.71,0,0,1-12.29,15.35A40.7,40.7,0,0,1,147.13,69.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.39,
    y: 9.11,
    width: 2.18,
    height: 60.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.66,91a24.6,24.6,0,0,1-12.3-3.29,24.87,24.87,0,0,1-9-9A24.59,24.59,0,1,1,88,78.7h0A24.6,24.6,0,0,1,66.66,91Zm0-47A22.41,22.41,0,1,0,86.07,77.61h0A22.42,22.42,0,0,0,66.66,44Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManagementGrundlagen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/management-grundlagen.5d751d79.svg";
export { ForwardRef as ReactComponent };